module.exports = __webpack_public_path__ + "img/video-octagon.2fd67049.svg";